module.exports = {"espace_apres_vente":"After-sales area","gerer_vos_retours_produit_et_votre_service_apres_vente":"Manage your product returns and after-sales service.","menu":"Menu","accueil":"Home","mes_produits":"My products","parametres":"Settings","se_deconnecter":"Sign out"}


//////////////////
// WEBPACK FOOTER
// ./src/companies/marketmaker/lang/en/home/template.lang.json
// module id = s7CP
// module chunks = 1